import { useFormik } from 'formik';
import * as Yup from 'yup';
import { DeliveryFormValues } from '../../../modules/DirectGoods/types';

interface UseDirectGoodsRequestFormikProps {
  onSubmit: (values: any, paginationConfig: any) => void;
}

//reject or accept
export const goodGestorDeliveryProcess = Yup.object({
  observations: Yup.string().required('Las observaciones son requeridas'),
  isAccepting: Yup.boolean(),
  token: Yup.string().when('isAccepting', {
    is: true,
    then: (schema) => schema.required('El token es obligatorio'),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
});

export const useGoodGestorDeliveryProcess = ({
  onSubmit,
}: UseDirectGoodsRequestFormikProps) => {
  return useFormik<DeliveryFormValues>({
    initialValues: {
      observations: '',
      token: null,
      isAccepting: false,
    },
    validationSchema: goodGestorDeliveryProcess,
    onSubmit,
  });
};
